import { ReactElement } from 'react'
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

import { paperInputSx } from '../../styles'

interface UserFiltersProps {
  searchQuery: string
  licenseTypeFilter: string
  availableLicenseTypes: string[]
  onSearchChange: (value: string) => void
  onLicenseTypeChange: (value: string) => void
}

export default function UserFilters({
  searchQuery,
  licenseTypeFilter,
  availableLicenseTypes,
  onSearchChange,
  onLicenseTypeChange,
}: UserFiltersProps): ReactElement {
  return (
    <Box className="grid grid-cols-1 gap-6 mb-4 md:grid-cols-2">
      <TextField
        fullWidth
        label="Search Users"
        placeholder="Search by name or email..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: <SearchIcon className="mr-2" />,
          },
        }}
        aria-label="Search users by name or email"
        sx={paperInputSx}
      />

      <FormControl fullWidth>
        <InputLabel id="license-type-filter-label">License Type</InputLabel>
        <Select
          labelId="license-type-filter-label"
          value={licenseTypeFilter}
          onChange={(e) => onLicenseTypeChange(e.target.value)}
          label="License Type"
          aria-label="Filter by license type"
          sx={{ backgroundColor: 'background.paper' }}
        >
          <MenuItem value="">
            <em>All License Types</em>
          </MenuItem>
          {availableLicenseTypes.map((licenseType) => (
            <MenuItem key={licenseType} value={licenseType}>
              {licenseType}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
